export function useIsTest() {
	const { hostname } = useRequestURL();

	const isTest = computed(() => {
		return hostname.includes("test.") || hostname.includes("staging.") || hostname === "localhost";
	});

	return isTest.value;
}
